<template>
  <div>
    <v-app>
      <Notification />
      <v-app-bar app clipped-right color="primary" dark>
        <router-link :to="{ name: 'summary-report' }">
          <v-icon class="mr-6">mdi-arrow-left</v-icon>
        </router-link>
        <v-toolbar-title>Maintenance</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout>
          <v-flex>
            <div class="float-right ml-3 mr-3">
              <v-layout class="pt-0">
                <v-flex>
                  <v-avatar size="42" class="ma-1 mr-2 mt-2 sae-img-border with-bg">
                    <img
                      :src="avatarUrl"
                      alt="Avatar"
                      onerror="this.onerror=null;this.src='/img/logo_initial_gradient.png'"
                    />
                  </v-avatar>
                </v-flex>
                <v-flex class="mt-1">
                  <p class="pa-0 ma-0 text-left bold">
                    <small class="uppercase">{{ userName | split }}</small>
                  </p>
                  <p class="pa-0 ma-0 text-left lowercase">
                    <small>{{ userEmail | split }}</small>
                  </p>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <template v-slot:extension>
          <v-tabs align-with-title slider-color="transparent" pills>
            <v-tab to="/maintenance/dashboards">Dashboard</v-tab>
            <v-menu bottom :offset-y="true" color="transparent" :open-on-hover="true">
              <template v-slot:activator="{ on, attrs }">
                <v-tab dark v-bind="attrs" v-on="on" class="mr-4">
                  Client
                  <v-icon right>mdi-menu-down</v-icon>
                </v-tab>
              </template>

              <v-list>
                <v-list-item to="/maintenance/company-data">Company Data</v-list-item>
                <v-list-item to="/maintenance/company-config">Company Config</v-list-item>
                <v-list-item to="/maintenance/payment">Payment History</v-list-item>
                <v-list-item to="/maintenance/check-in-history">Check-in History</v-list-item>
                <v-list-item to="/maintenance/user-per-company-history">Total Users</v-list-item>
              </v-list>
            </v-menu>

            <v-menu bottom :offset-y="true" color="transparent" :open-on-hover="true">
              <template v-slot:activator="{ on, attrs }">
                <v-tab dark v-bind="attrs" v-on="on" class="mr-4">
                  Support
                  <v-icon right>mdi-menu-down</v-icon>
                </v-tab>
              </template>

              <v-list>
                <v-list-item to="/maintenance/user-data">User Data</v-list-item>
                <v-list-item to="/maintenance/user-analytics">User Analytics</v-list-item>
                <!-- <v-list-item to="/maintenance/manual-cleansing">Manual Cleansing</v-list-item> -->
              </v-list>
            </v-menu>

            <v-menu bottom :offset-y="true" color="transparent" :open-on-hover="true">
              <template v-slot:activator="{ on, attrs }">
                <v-tab dark v-bind="attrs" v-on="on" class="mr-4">
                  Manage
                  <v-icon right>mdi-menu-down</v-icon>
                </v-tab>
              </template>

              <v-list>
                <v-list-item to="/maintenance/news-feed-master">News Feed</v-list-item>
              </v-list>
            </v-menu>
          </v-tabs>
        </template>
      </v-app-bar>

      <v-main>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-main>

      <!-- <v-footer app color="primary lighten-3" class="white--text">
        <span>Appsensi</span>
        <v-spacer></v-spacer>
        <span>&copy; 2020</span>
      </v-footer>-->
    </v-app>
  </div>
</template>
<script>
import Notification from './../components/Notification';
import firebase from "firebase";

export default {
  components: { Notification },
  name: "MaintenanceLayout",
  data() {
    return {
      user: { avatar_url: '' },
      drawer: false,
      drawerRight: false
    };
  },
  computed: {
    avatarUrl() {
      return this.$store.state.user.avatar;
    },
    userName() {
      return this.$store.state.user_name;
    },
    userEmail() {
      return this.$store.state.user_email;
    },
  },
  async created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user.avatar_url =
          "https://storage.cloud.google.com/appsensi-dev.appspot.com/images/avatars/" +
          user.uid;
      }
    });
  }
};
</script>
<style scoped>
.uppercase {
  text-transform: uppercase!important;
}
</style>